import axios from "axios";
const CONTROLLER_PATH = "MedikreditClaim";
class ClaimService {
    //CREATE
    createaccountfromclaim(claimId) {
        return axios.post(CONTROLLER_PATH + "/createaccountfromclaim/" + claimId).then((response) => ({
            data: response.data,
        }));
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/" + id, { requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }
    getreducedview(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + "/GetReducedView" + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    //UPDATE

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new ClaimService();
